import React from 'react';
import { EnRouteFlightDataProps } from './types';
import { useFlightProvider } from '@src/features/order/provider';
import { ArcCellInfo, ArcStack, ArcText } from '@src/core/ui';
import { arcLatToDMS, arcLngToDMS, arcSpatium, arcToFixed, arcVelocitas } from '@src/core/extensions';
import { EMPTY_STRING } from '@src/core/config';

const cellInfoWidth = 'calc(50% - 8px)';

const EnRouteFlightData: React.FC<EnRouteFlightDataProps> = () => {
  const { flightData, distanceSensor, vhrNud } = useFlightProvider();

  return (
    <ArcStack
      p={2.5}
      py={3}
      sx={{
        borderRadius: '4px',
        border: (theme) => `0.5px solid ${theme.palette.border.muted}`,
      }}
    >
      <ArcStack gap={2} direction='row' flexWrap='wrap'>
        <ArcCellInfo 
          label='V - SPEED' 
          width={cellInfoWidth}> 
          {arcVelocitas(-(vhrNud?.climb_rate_m_s ?? 0))}
        </ArcCellInfo>
        <ArcCellInfo 
          label='H - SPEED' 
          width={cellInfoWidth}> 
          {arcVelocitas(vhrNud?.groundspeed_m_s)}
        </ArcCellInfo>

        <ArcCellInfo 
          label='TOTAL DIST' 
          width={cellInfoWidth}> 
          {arcToFixed(flightData?.actualDistance)} m
        </ArcCellInfo>
        <ArcCellInfo 
          label='ETA' 
          width={cellInfoWidth}> 
          {EMPTY_STRING}
        </ArcCellInfo>

        <ArcCellInfo 
          label='LATITUDE' 
          width={cellInfoWidth}> 
          {arcLatToDMS(flightData.latitude)}
        </ArcCellInfo>

        <ArcCellInfo 
          label='LONGITUDE' 
          width={cellInfoWidth}> 
          {arcLngToDMS(flightData.longitude)}
        </ArcCellInfo>

        <ArcCellInfo 
          label='HOME ALT' 
          width={cellInfoWidth}> 
          {arcSpatium(flightData.altitude)}
        </ArcCellInfo>

        <ArcCellInfo 
          label='AGL' 
          width={cellInfoWidth}> 
          <ArcText.h6 fontWeight={700}> {arcSpatium(distanceSensor?.current_distance_m)} </ArcText.h6>
        </ArcCellInfo>
      </ArcStack>
    </ArcStack>
  );
};

export default EnRouteFlightData;